import axios from "axios";

export const getUserJWT = () => {
    const jwt = JSON.parse(localStorage.getItem("jwt"));
    let data =
        jwt !== null
            ? {
                  headers: {
                      Authorization: `Token ${jwt.token}`,
                  },
              }
            : {};

    axios.defaults.withCredentials = true;
    return data;
};

export const getHeaders = () => {
    const jwt = JSON.parse(localStorage.getItem("jwt"));
    let headers =
        jwt !== null
            ? {
                  Authorization: `Token ${jwt.token}`,
              }
            : {};

    return headers;
};

export const getJWTUserInfo = () => {
    const jwt = JSON.parse(localStorage.getItem("jwt"));
    let user = {};
    if (jwt !== null) {
        user = { ...jwt.user };
        if (user.image !== undefined) {
            user.image = {
                preview: jwt.user.image,
                raw: jwt.user.image,
            };
        }
        user.birthday = new Date(jwt.user.birthday);
    }

    return user;
};

export const isAuth = () => {
    return localStorage.getItem("jwt") !== null ? true : false;
};
